import React, { useCallback, useMemo, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { birthdateFormat } from '../../../../utils/patientUtils'
import { getAgeHeaderDisplay } from 'utils/patientAgeDisplay'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import moment from 'moment'
import { trackEvent } from 'utils/analyticsUtils'
import { makeStyles } from '@material-ui/core'
import { getLocalDateFromISO } from 'utils/dateUtils'

const useStyles = makeStyles({
  date: {
    padding: '2px 4px 2px 4px',
    transition: 'background-color 0.5s'
  },
  editable: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'var(--bg-color-patient-card-field)'
    }
  }
})

const PatientAge = ({ age, birthdate, isDisabled, onChange }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const [currentBirthdate, setCurrentBirthdate] = useState(birthdate)
  const [isEditMode, setIsEditMode] = useState(false)

  const utcBirthdate = useMemo(() => getLocalDateFromISO(currentBirthdate), [currentBirthdate])

  const { i18nKey, age: ageText } = useMemo(
    () => getAgeHeaderDisplay({ hasBirthdate: !!currentBirthdate, age, naText: t('dialogs.patientInfo.na') }),
    [currentBirthdate, age, t]
  )

  const handleAgeUpdated = useCallback(
    newBirthdate => {
      const parsedNewBirthdate = moment.utc(moment(newBirthdate).format('YYYY-MM-DD')).toISOString()
      setCurrentBirthdate(parsedNewBirthdate)

      trackEvent('Patient card - Age updated', {
        newBirthdate: parsedNewBirthdate,
        isFirstTime: !birthdate
      })
      onChange({ birthdate: parsedNewBirthdate })
    },
    [birthdate, onChange]
  )

  return (
    <>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DatePicker
          variant="dialog"
          open={isEditMode}
          disableFuture
          value={utcBirthdate}
          onChange={handleAgeUpdated}
          onClose={() => setIsEditMode(false)}
          TextFieldComponent={() => (
            <DazzedParagraph14
              onClick={() => (isDisabled ? {} : setIsEditMode(true))}
              className={`${classes.date} ${isDisabled ? '' : classes.editable}`}
            >
              <Trans
                values={{
                  age: ageText,
                  birthdate: birthdateFormat(currentBirthdate)
                }}
                i18nKey={i18nKey}
                components={{ bold: <b>{''}</b> }}
              />
            </DazzedParagraph14>
          )}
        />
      </MuiPickersUtilsProvider>
    </>
  )
}

export default PatientAge
